import React from 'react';
import { RouteOff } from 'lucide-react';
import { ROUTE_PLACEHOLDER } from '@radevents/shared';

/**
 * Hält auf der Detailseite die Stelle der Streckenkarte frei, wenn die gewählte Distanz keine
 * Karte hat, andere Distanzen desselben Events aber schon. Wann er erscheint, entscheidet
 * `showRoutePlaceholder` in `@radevents/shared`.
 *
 * Das feine Raster nimmt den Kartengrund der App-Streckenkarte auf, damit der Kasten als
 * „Karte fehlt" gelesen wird und nicht als leere Fläche.
 */
const RouteMapPlaceholder: React.FC<{ height?: number }> = ({ height = 220 }) => (
  <div
    data-testid="route-map-placeholder"
    style={{
      height,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      padding: '0 24px',
      textAlign: 'center',
      background: '#F5F3F3',
      backgroundImage:
        'linear-gradient(#E5E1E1 1px, transparent 1px), linear-gradient(90deg, #E5E1E1 1px, transparent 1px)',
      backgroundSize: '26px 26px',
    }}
  >
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 44, height: 44, borderRadius: 999, background: '#FFFFFF', border: '1px solid #E5E1E1', color: '#6A6A6A',
    }}>
      <RouteOff size={20} aria-hidden />
    </span>
    <div style={{ fontFamily: "'Archivo',sans-serif", fontWeight: 700, fontSize: 16, color: '#2C2C2C' }}>
      {ROUTE_PLACEHOLDER.title}
    </div>
    <div style={{ fontFamily: "'Hanken Grotesk',sans-serif", fontSize: 14, color: '#4A4A4A', maxWidth: 380 }}>
      {ROUTE_PLACEHOLDER.text}
    </div>
  </div>
);

export default RouteMapPlaceholder;
